export enum LanguageCode {
    Bulgarian = 'bg',
    Croatian = 'hr',
    English = 'en',
    Hungarian = 'hu',
    Romanian = 'ro',
    Slovenian = 'sl',
}
